import { Moment } from 'moment';
import { Note } from './notes';

/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

export enum SignatureStatus {
    NOT_SENT = 'NOT SENT',
    SENT = 'SENT',
    SIGNED = 'SIGNED',
    DECLINED = 'DECLINED',
}
export interface AgreementStatus {
    signatureId: string;
    signatureStatus: SignatureStatus;
    document?: DocFile;
}

export interface RegisteredContractor {
    uuid: string;
    _id: string;
    signatureId?: string;
    signatureStatus?: SignatureStatus;
    registerForLaborJobs?: boolean;
    agreements: Record<string, AgreementStatus>;
    companyInfo: CompanyInfo;
    teamInfo: TeamInfo;
    serviceArea: string;
    documents: ContractorDocuments;
    trades: Trade[];
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    created: string;
    lastModified: string;
    status: string;
    notes: Note[];
    messages?: Message[];
}

export interface Message {
    accountId: number;
    fullName: string;
    email: string;
    created: Moment;
    type: string;
}

export interface ProjectQueryType {
    uuid: number;
    _id: number;
    companyInfo: number;
    teamInfo: number;
    serviceArea: number;
    documents: number;
    trades: number;
    firstName: number;
    lastName: number;
    email: number;
    phone: number;
    created: number;
    lastModified: number;
    status: number;
    notes: number;
}

export interface RegistrationFilterQuery {
    where?: Partial<RegisteredContractor> | any;
    limit?: number;
    skip?: number;
    sort?: Partial<ProjectQueryType>;
    project?: Partial<ProjectQueryType>;
}

export interface StarterInfo {
    name: string;
    email: string;
    phone: string;
}

export interface Trade {
    type: string;
    subCategories: string[];
}

export interface CompanyInfo {
    name: string;
    website: string;
    companyAddress: AddressCreation;
    billingAddress: AddressCreation;
    useCompanyAddressAsBilling: boolean;
    corporationType: string;
}
export interface TeamInfo {
    systemInstalls: string;
    serviceCalls: string;
    masterTechs: string;
    employees: string;
    singleFamilyServiceProvider: boolean;
    multiDwellingServiceProvider: boolean;
    commercialServiceProvider: boolean;
}

export interface ContractorDocuments {
    epaCertification: DocFile[];
    w9: DocFile[];
    tradeLicenses: Qualification[];
    certificateOfLiability: DocFile[];
    flatRatePayoutAgreement?: DocFile[];
    codeOfConduct: DocFile[];
    companyMSA?: DocFile[];
    masterServiceAgreement?: DocFile[];
}
export interface Qualification {
    id?: number;
    type: string;
    fileName: string;
    file: DocFile;
    fileId: number;
    tradeTypeId: string;
    tradeSubTypeId: string;
    contractorId: number;
}

export interface DocFile {
    category?: string;
    name: string;
    resourceType: string;
    key: string;
    url: string;
    secureUrl: string;
    timeStamp: string;
    validFrom: string | null | undefined;
    validTo: string | null | undefined;
    bucket: string;
    source: string;
}

export enum MaskNames {
    PHONE = 'phone',
    DATE = 'date',
}

export interface AddressCreation {
    address1: string;
    address2: string;
    city: string;
    zip: string;
    state: string;
}
